// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { CancellationToken } from "@lib/utilities/CancellationToken";

/**
 * Signals to a `CancellationToken` that it should be canceled.
 * Similar to .NETs `CancellationTokenSource`.
 */
export class CancellationTokenSource
{
  private cancelCallback: Optional<() => void>;

  readonly token: CancellationToken;

  constructor()
  {
    this.token = new CancellationToken(cancel =>
    {
      this.cancelCallback = cancel;
    });
  }

  cancel()
  {
    if (this.cancelCallback)
    {
      this.cancelCallback();
      this.cancelCallback = undefined;
    }
  }
}